import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';

import { SessionService } from '../../store/services/session.service';
import { filter, map } from 'rxjs/operators';
import { UserType } from 'app/store/models/user.model';

@Injectable()
export class MasterGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const roles = route.data.roles as UserType[];
    return this.sessionService.onReady()
      .pipe(
        filter(session => !!session),
        map(session => {
          if (roles && roles.some((role) => role === session.user_type && role !== UserType.MASTER)) {
            return true;
          }
          return session.user_type === UserType.MASTER && session.id === 1 ? true : this.router.createUrlTree(['/']);
        }),
      );
  }
}
